module.exports = __webpack_public_path__ + "static/leader7-8419f3d5709772d8c5cf6ee7f907be7c.jpg";